import React, {useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import styled from "styled-components";
import ItemsCarousel from 'react-items-carousel';
import { ReactComponent as RightIcon } from './../../../Assets/Icons/arrow_right.svg';
import { ReactComponent as LeftIcon } from './../../../Assets/Icons/arrow_left.svg';
import useWindowSize from './../../../utils/useWindowSize';
import StoriesCard from "../StoriesCard";
import ArrowButton from "./../../Atoms/ArrowButton"

const Wrapper = styled(Div)`
  .carousel-wrapper > div {
    overflow-x: unset;
  }
`;

const StyledCard = styled.div`
  margin: 2rem 0 !important;
`;

function StoriesSlider(props) {

  const [activeItemIndex, setActiveItemIndex] = useState(0);
  const chevronWidth = 0;

  const size = useWindowSize();
  let cardNum = 2.5;
  if (size.width > 920) {
    cardNum = 2.5
  } else if (size.width > 766) {
    cardNum = 2;
  } else if (size.width > 500) {
    cardNum = 1.5;
  } else {
    cardNum = 1;
  }

  return (
    <Wrapper
      m={{ y: '2rem'}}
      style={{ padding: `0 ${chevronWidth}px` }}
    >
      <ItemsCarousel
        requestToChangeActive={setActiveItemIndex}
        activeItemIndex={activeItemIndex}
        numberOfCards={cardNum}
        gutter={20}
        leftChevron={<ArrowButton aria-label={'scroll activity bundles left'}>{ <LeftIcon />}</ArrowButton>}
        rightChevron={<ArrowButton aria-label={'scroll activity bundles right'}>{<RightIcon/>}</ArrowButton>}
        outsideChevron
        chevronWidth={chevronWidth}
        classes={{ wrapper: 'carousel-wrapper' }}
        showSlither={true}
      >
        {
          props.stories.map( (story, i) => {
            return (
              <StyledCard
                key={story.id + i}
              >
                <StoriesCard
                  id={story.id}
                  title={story.title}
                  story={story}
                />
              </StyledCard>
            )
          })
        }
      </ItemsCarousel>
    </Wrapper>
  )
}

export default StoriesSlider
